export default __webpack_public_path__ + "static/media/RadioButton.20df552d.svg";